/*
Copyright (C) 2020 Broadleaf Commerce.

Licensed under the Broadleaf End User License Agreement (EULA),
Version 1.1 (the “Commercial License” located at
http://license.broadleafcommerce.org/commercial_license-1.1.txt).

Alternatively, the Commercial License may be replaced with a mutually
agreed upon license (the “Custom License”) between you and
Broadleaf Commerce. You may not use this file except in compliance
with the applicable license.
*/
import React from 'react';
import classNames from 'classnames';
import SimpleModal from '@broadleaf/admin-components/dist/common/components/SimpleModal';
import Spinner from '@broadleaf/admin-components/dist/common/elements/Spinner';

export const MarkInvoicesPaidModal: React.FC<SubmitInvoicesModalProps> = props => {
  const { allSelectedItems, onClose } = props;
  return (
    <SimpleModal
      /*// @ts-ignore */
      closeOnClickOutside={false}
      isOpen
      onClose={onClose}
      size="lg"
      title={<>Mark Invoices Paid</>}
      footer={
        <div>
          <SubmitButton
            submitLabel={'Submit'}
            submitInvoices={props.submitInvoices}
            isSubmitting={props.isSubmitting}
          />{' '}
        </div>
      }
    >
      <ModalBody {...props} />
    </SimpleModal>
  );
};

export interface SubmitInvoicesModalProps {
  allSelectedItems: any[];
  submitInvoices: () => void;
  isSubmitting: boolean;
  onClose: () => void;
}

const ModalBody: React.FC<SubmitInvoicesModalProps> = props => {
  const { allSelectedItems, submitInvoices, onClose } = props;
  const itemsRequirePO = allSelectedItems.filter(
    item => item.invoiceStatus === 'REQUIRES_PO'
  );
  const itemsCreditPending = allSelectedItems.filter(
    item => item.invoiceStatus === 'CREDIT_PENDING'
  );
  return (
    <div>
      <div>Mark {allSelectedItems.length} invoice(s) paid?</div>
    </div>
  );
};

const SubmitButton = ({
  isSubmitting,
  submitLabel,
  isDisabled = false,
  submitInvoices
}) => {
  return (
    <>
      <button
        disabled={isSubmitting || isDisabled}
        className={classNames(
          'tw-text-md focus:tw-shadow-outline tw-w-full tw-rounded tw-border tw-bg-primary-500 tw-px-4 tw-py-4 tw-font-semibold tw-text-primary-100 tw-shadow hover:tw-bg-primary-600 focus:tw-outline-none md:tw-w-auto md:tw-py-2',
          {
            'tw-cursor-not-allowed': isSubmitting || isDisabled
          }
        )}
        onClick={() => submitInvoices()}
        style={{ opacity: isSubmitting ? '0.65' : '1' }}
        type="submit"
      >
        {' '}
        {submitLabel}{' '}
        {isSubmitting && (
          <Spinner
            size="md"
            className="tw-ml-2"
            innerClassName="tw-border-gray-100"
          />
        )}
      </button>
    </>
  );
};

export default MarkInvoicesPaidModal;
